module.exports = __webpack_public_path__ + "static/media/splash2_3x.38a7fde6.jpg";